import { gql } from "@apollo/client";


export const GET_ESTADOS_SUGERENCIAS_MONITOREO = gql`
query estadosProfesionalMonitoreoSugerencia{
    estadosProfesionalMonitoreoSugerencia{
        idEstadoProfesionalMonitoreoSugerencia
        codigo
        descripcion
    }
}
`;

const adaptEstadoRow = (estado) => {
  return {
    id: estado?.idEstadoProfesionalMonitoreoSugerencia,
    codigo: estado?.codigo,
    displayName: estado?.descripcion
  };
};

export const adaptEstadosSugerenciaArray = (estados) => {
  return (
    structuredClone(
      estados?.estadosProfesionalMonitoreoSugerencia
    )?.map((estado) => adaptEstadoRow(estado)) || []);

};